import { SmartStyle } from "../tools/styled.span";

/**
 * The basic unit of data lists and trees.
 */
export interface DataItem {
  /**
   * The text to show on the item
   */
    name: string,

    /**
     * The value represented by the item.
     */
    value: any,

    /**
     * Child data items.
     */
    children?: DataItem[],

    /**
     * Styling the appearance of the item.
     */
    style?: SmartStyle,
  }